// extracted by mini-css-extract-plugin
export default {"footer":"DashboardFooter_footer__v6YNt","footer-text":"DashboardFooter_footer-text__2XAev","footer-link":"DashboardFooter_footer-link__+PcIW"};